module.exports = __webpack_public_path__ + "static/img/cj01.7c4c7a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj01.png
// module id = 145
// module chunks = 0